export const exclusionLimit = 6;



// WEBPACK FOOTER //
// ./src/modules/funnel/constants/exclusionConfig.js